import { formatCurrency, formatDate } from "@/common/utils/formatters";
import { ArrowBigRight } from "lucide-react";
import { BillData } from "../types/bills.type";
import { Link } from "react-router-dom";
import { billingBillStatus } from "../constants/billingBillStatus.constant";
import BillDateWithTimezone from "@/common/components/BillDateWithTimezone";
import { formatDatePeriodFriendlyName } from "@/common/utils/dateTransformer";

export class BillsTransformer {
  static tableTransformer() {
    return (bills: BillData[]) => {
      return bills.map((bill) => ({
        ...bill,
        period: formatDatePeriodFriendlyName({
          closedAt: bill.closed_at,
          openedAt: bill.opened_at,
          contractualCycle: bill.contractual_cycle,
        }),
        status: bill.status ? billingBillStatus[bill.status] : '',
        credit_info: bill?.granted_credit ? formatCurrency(parseFloat(`${bill?.granted_credit}`)) : undefined,
        total_amount: bill?.total_amount ? formatCurrency(parseFloat(`${bill?.total_amount}`)) : "Não informado",
        events_count: `${bill.events_count || 0} transações`,
        opened_at: bill.opened_at && (
          <BillDateWithTimezone
            date={bill.opened_at}
            timezone={bill.time_zone}
          />
        ),
        closed_at: bill.closed_at && (
          <BillDateWithTimezone
            date={bill.closed_at}
            timezone={bill.time_zone}
          />
        ),
        due_at: bill.due_at && (
          <BillDateWithTimezone
            date={bill.due_at}
            timezone={{ 
              id: 'america_sao_paulo',
              acronym: 'BRT',
              display_name: 'América - São Paulo',
              identifier: 'America/Sao_Paulo',
              offset: '-03:00',
            }}
            hideTimezone
          />
        ),
        actions: <Link to={bill.id}><ArrowBigRight /></Link>,
      }));
    };
  }

  static quickSearchModelTransformer() {
    return (bills: BillData[]) => {
      return bills.map((bill) => ({
        route: `/billing-bills/${bill.id}`,
        items: [
          ['Status', bill.status ? billingBillStatus[bill.status] : ''],
          ['Código', bill.number],
          ['Abertura', bill.opened_at && formatDate(new Date(bill.opened_at))],
          ['Fechamento', bill.closed_at && formatDate(new Date(bill.closed_at))],
          ['Período', formatDatePeriodFriendlyName({
            closedAt: bill.closed_at,
            openedAt: bill.opened_at,
            contractualCycle: bill.contractual_cycle,
          })],
        ],
      }));
    };
  }
}
